export default __webpack_public_path__ + "static/header-help-f135e855bc313cd9c212f415ee166d3d.svg";